/* eslint-disable */
import React from 'react'
import http from '../../Component/Interceptor/Interseptor'
import {Button, Container, Modal, ModalBody, ModalFooter, ModalHeader} from 'mdbreact'
import Page from '../Pagination/Pagination'
import HeaderTable from '../BaseComponent/HeaderTable'
import $ from 'jquery'
import {message} from 'antd'
import jMoment from 'moment-jalaali'
import {Link} from 'react-router-dom'
import cookie from 'react-cookies'
import REPORT_RETAIL from '../BaseComponent/REPORTRETAIL'
import HeaderTablePrint from '../BaseComponent/HeaderTablePrint'
import ExcelExport from '@progress/kendo-react-excel-export/dist/npm/ExcelExport'
import FromToPicker from '../BaseComponent/FromToPicker'
import {accounting} from 'accounting'
import SearchCustomer from '../BaseComponent/SearchCustomer'

class UsersTransaction extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      printInfo: [],
      pageNumber: 1,
      buttonClicked: false,
      transaction: [],
      fromDate: '',
      toDate: '',
      fromPrintDate: '',
      toPrintDate: '',
      customerCode: ''
    }
  }

  getTransactionUser = (
    pageNumber = sessionStorage.getItem('pageNumber'),
    pageSize = sessionStorage.getItem('dropDownVal'),
    params = sessionStorage.getItem('params')
  ) => {
    http
      .get(
        `${
          REPORT_RETAIL.REPORT_RETAIL_CUSTOMER_TRANSACTION_MULTIPLE
        }?export=false&pageNumber=${pageNumber}&pageSize=${pageSize}&${params}`,
        {}
      )
      .then((response) => {
        if (response.data.error === null) {
          $('.showBaseTable,.print').fadeIn()
          this.setState({
            transaction: response.data.object.result,
            countAll: response.data.object.countAll,
            buttonClicked: true
          })
        } else {
          $('.showBaseTable,.print').fadeOut()
          this.setState({
            transaction: [],
            countAll: 0
          })
          message.error(response.data.description)
        }
      })
  }

  componentDidMount() {
    sessionStorage.removeItem('params')

    $(function() {
      $('.filterBtn').on('click', function() {
        $('.basketFilterComponent').slideToggle()
      })
    })

    sessionStorage.setItem('pageNumber', '1')
    sessionStorage.setItem('dropDownVal', '10')
  }

  onResultFetched(data) {
    this.setState({
      transaction: data
    })
  }

  changeDropDown(data) {
    this.setState({
      transaction: data,
      lengthProducts: this.state.countAll
    })
  }

  convertDigit = (string) => {
    return string
      .replace(/[\u0660-\u0669]/g, function(c) {
        return c.charCodeAt(0) - 0x0660
      })
      .replace(/[\u06f0-\u06f9]/g, function(c) {
        return c.charCodeAt(0) - 0x06f0
      })
  }

  handleChangeFromDate = (fromDate) => {
    this.setState({
      fromDate
    })
  }

  handleChangeToDate = (toDate) => {
    this.setState({
      toDate
    })
  }

  getSingleCustomerCode = (customerCode) => {
    this.setState({
      customerCode
    })
  }

  filter() {
    sessionStorage.setItem('pageNumber', '1')
    sessionStorage.setItem('dropDownVal', '10')
    let registerDateMin = this.state.fromDate
    let registerDateMax = this.state.toDate
    let customerCode = this.state.customerCode
    var transactionId = document.getElementById('transactionId').value
    var invoiceId = document.getElementById('invoiceId').value.trim()
    var paymentId = document.getElementById('paymentId').value.trim()
    var amountMin = document.getElementById('amountMin').value.trim()
    var amountMax = document.getElementById('amountMax').value.trim()
    let sortAscending = document.getElementById('sortAscending').value
    if (registerDateMin === '' || registerDateMax === '') {
      message.error('هر دو تاریخ وارد شود')
    } else if ((registerDateMin != '' || registerDateMin == null) && isNaN(registerDateMin)) {
      message.error('فرمت تاریخ ثبت ابتدا صحیح نیست')
    } else if ((registerDateMax != '' || registerDateMax == null) && isNaN(registerDateMax)) {
      message.error('فرمت تاریخ ثبت انتها صحیح نیست')
    } else {
      sessionStorage.setItem(
        'params',
        `sortAscending=${sortAscending}&amountMax=${amountMax}&amountMin=${amountMin}&paymentId=${paymentId}&invoiceId=${invoiceId}&transactionId=${transactionId}&registerDateMin=${registerDateMin}&registerDateMax=${registerDateMax}&customerCode=${customerCode}`
      )
      this.getTransactionUser()
      this.setState({
        toPrintDate: registerDateMax == '' ? '-' : jMoment(this.state.toDate).format('jYY/jMM/jDD'),
        fromPrintDate: registerDateMin == '' ? '-' : jMoment(this.state.fromDate).format('jYY/jMM/jDD')
      })
    }
  }

  getPrintInfo = () => {
    http
      .get(
        `${REPORT_RETAIL.REPORT_RETAIL_CUSTOMER_TRANSACTION_MULTIPLE}?export=true&${sessionStorage.getItem('params')}`,
        {}
      )
      .then((response) => {
        if (response.data.error == null) {
          sessionStorage.setItem('countAll', response.data.object.countAll)

          this.setState({
            printInfo: response.data.object.result,
            lengthRemains: response.data.object.countAll
          })
        } else {
          this.setState({
            printInfo: []
          })
          message.error(response.data.description)
        }
        // alert(JSON.stringify(response.data))
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  exportPrint = () => {
    var css = '@page { size:A4 portrait;}',
      head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style')

    style.type = 'text/css'
    style.media = 'print'

    if (style.styleSheet) {
      style.styleSheet.cssText = css
    } else {
      style.appendChild(document.createTextNode(css))
    }

    head.appendChild(style)
    this.getPrintInfo()
    setTimeout(() => {
      window.print()
    }, 2000)
  }

  exportExcel = () => {
    http
      .get(
        `${
          REPORT_RETAIL.REPORT_RETAIL_CUSTOMER_TRANSACTION_MULTIPLE
        }?export=true&pageSize=10&pageNumber=1&${sessionStorage.getItem('params')}`,
        {}
      )
      .then((response) => {
        if (response.data.error == null) {
          console.log(response.data)

          sessionStorage.setItem('countAll', response.data.object.countAll)
          this.setState({
            excelReport: response.data.object.result
          })
          let result = response.data.object.result
          let {excelReport} = this.state

          for (let i = 0; i < excelReport.length; i++) {
            excelReport[i]['registerDate'] = jMoment(excelReport[i]['registerDate']).format('jYY/jM/jD HH:mm')
          }
          this._export.save(this.state.excelReport)
        } else {
          this.setState({
            excelReport: []
          })
        }
      })
      .catch((error) => {})
  }

  render() {
    let pageNumber = sessionStorage.getItem('pageNumber')
    let params = sessionStorage.getItem('params')
    let name = cookie.load('name')
    let columns = [
      'ردیف',
      'تاریخ ثبت',
      'کاربر',
      'شناسه تراکنش',
      'شناسه فاکتور',
      'شناسه پرداخت',
      'نوع پرداخت',
      'شرح پرداخت',
      'مبلغ هر تراکنش'
    ]

    let excelColumns = [
      {title: 'کد محصول', value: 'articleId'},
      {title: 'بارکد محصول', value: 'productCode'},
      {title: 'نام محصول', value: 'productName'},
      {title: 'نام انبار', value: 'warehouseName'},
      {title: 'نام تامین کننده', value: 'providerName'}
    ]

    return (
      <div className="rtl printA4Page">
        <div className="printSection">
          <table className="printTable printReportTable" ref={(node) => (this.printPart = node)}>
            <HeaderTablePrint
              header="گزارش تراکنش های کاربران "
              headerColSpan={9}
              reporter={name}
              timePrint={jMoment().format('jYYYY/jM/jD HH:mm')}
              leftColSpan={3}
              rightColSpan={3}
              centerColSpan={3}
              centerSection={''}
              rightSection={'تاریخ از ' + this.state.fromPrintDate + 'تا ' + this.state.toPrintDate}
              columns={columns}
            />
            <tbody>
              {this.state.printInfo.map((transaction, index) => (
                <tr key={'i' + index}>
                  <td>{index + 1}</td>
                  <td>{jMoment(transaction.registerDate).format('jYY/jM/jD HH:mm')}</td>
                  <td>{transaction.customer.userCode + ' - ' + transaction.customer.name}</td>
                  <td>{transaction.transactionId}</td>
                  <td>{transaction.invoiceId}</td>
                  <td>{transaction.paymentId}</td>
                  <td>{transaction.payment === null ? '-' : transaction.payment.methodName}</td>
                  <td>{transaction.payment === null ? '-' : transaction.payment.description}</td>
                  <td className="priceCell">{accounting.formatMoney(transaction.amount, '', ',')}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="excelSection">
          <ExcelExport
            dir="rtl"
            ref={(exporter) => {
              this._export = exporter
            }}
            fileName="گزارش تراکنش های کاربران.xls"
          >
            <grid style={{height: '420px'}} data={this.state.excelReport}>
              <gridColumn
                key={'registerDate'}
                field={'registerDate'}
                title={'تاریخ ثبت'}
                width="120"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'userCode'}
                field={'customer.userCode'}
                title={'کد کاربر'}
                width="120"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'name'}
                field={'customer.name'}
                title={'نام کاربر'}
                width="120"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'transactionId'}
                field={'transactionId'}
                title={'شناسه تراکنش'}
                width="120"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'invoiceId'}
                field={'invoiceId'}
                title={'شناسه فاکتور'}
                width="120"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'paymentId'}
                field={'paymentId'}
                title={'شناسه پرداخت'}
                width="120"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'methodName'}
                field={'payment.methodName'}
                title={'نوع پرداخت'}
                width="120"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'description'}
                field={'payment.description'}
                title={'شرح پرداخت'}
                width="120"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'amount'}
                field={'amount'}
                title={'مبلغ تراکنش'}
                width="120"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
            </grid>
          </ExcelExport>
        </div>

        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>گزارشات</li>
            <li>گزارش تراکنش های کاربران</li>
          </ul>
          <div className="tableComponent">
            <div className="tableTools">
              <div className="tableOptionWrapp">
                <HeaderTable
                  addUrl=""
                  url={REPORT_RETAIL.REPORT_RETAIL_CUSTOMER_TRANSACTION_MULTIPLE}
                  ChangeDropDown={this.changeDropDown.bind(this)}
                  printUrl="test"
                  printComponent={this.printTable}
                  titleAdd=""
                  execelUrl=""
                  excelColumns={excelColumns}
                  printLink=""
                />
                <button className="filterBtn">
                  <i className="fa fa-search" />
                </button>
                <button
                  className={'printButton'}
                  disabled={this.state.buttonClicked ? false : true}
                  onClick={this.exportExcel}
                >
                  <i className="fas fa-file-excel" />
                </button>
                <button
                  className="printButton"
                  disabled={this.state.buttonClicked ? false : true}
                  onClick={this.exportPrint}
                >
                  <i className="fas fa-print" />
                </button>
              </div>
            </div>
            <div className="basketFilterComponent">
              <div className="filterInputs">
                <SearchCustomer
                  label={'کد مشتری'}
                  getSingleCustomerCode={this.getSingleCustomerCode}
                  singleResult={true}
                  searchLabel={'جست و جوی مشتری'}
                />

                <FromToPicker
                  onChangeFromDate={this.handleChangeFromDate}
                  onChangeToDate={this.handleChangeToDate}
                  fromLabel="تاریخ ثبت از"
                  toLabel="تاریخ ثبت تا"
                  defaulValue={true}
                  fromId="registerDateMin"
                  toId="registerDateMax"
                  force={true}
                />
                <div className="formComponent">
                  <label>شناسه تراکنش</label>
                  <input type="text" className="form-control" id="transactionId" />
                </div>

                <div className="formComponent">
                  <label>شناسه فاکتور</label>
                  <input type="text" className="form-control" id="invoiceId" />
                </div>
                <div className="formComponent">
                  <label>شناسه پرداخت</label>
                  <input type="text" className="form-control" id="paymentId" />
                </div>
                <div className="formComponent">
                  <label>مبلغ تراکنش از</label>
                  <input type="text" className="form-control" id="amountMin" />
                </div>
                <div className="formComponent">
                  <label>مبلغ تراکنش تا</label>
                  <input type="text" className="form-control" id="amountMax" />
                </div>
                <div className="formComponent">
                  <label>ترتیب نمایش</label>
                  <select className="form-control" id="sortAscending">
                    <option value={0}>نزولی</option>
                    <option value={1}>صعودی</option>
                  </select>
                </div>
              </div>
              <div className="filterOption">
                <button className="confirmFilter" onClick={this.filter.bind(this)}>
                  جست و جو
                </button>
              </div>
            </div>

            <div className="showBaseTable print">
              <table className="baseTable">
                <tbody>
                  <tr className="firstRow">
                    <td>ردیف</td>
                    <td>تاریخ ثبت</td>
                    <td>کاربر</td>
                    <td>شناسه تراکنش</td>
                    <td>شناسه فاکتور</td>
                    <td>شناسه پرداخت</td>
                    <td>نوع پرداخت</td>
                    <td>شرح پرداخت</td>
                    <td>مبلغ تراکنش</td>
                  </tr>
                  {this.state.transaction.map((transaction, index) => (
                    <tr key={index}>
                      <td>{(pageNumber - 1) * 10 + index + 1}</td>
                      <td>{jMoment(transaction.registerDate).format('jYY/jM/jD HH:mm')}</td>
                      <td>{transaction.customer.userCode + ' - ' + transaction.customer.name}</td>
                      <td>{transaction.transactionId}</td>
                      <td>
                        <Link target="_blank" to={`/baskets?invoiceId=${transaction.invoiceId}`}>
                          {transaction.invoiceId}
                        </Link>
                      </td>
                      <td>{transaction.paymentId}</td>
                      <td>{transaction.payment === null ? '-' : transaction.payment.methodName}</td>
                      <td>{transaction.payment === null ? '-' : transaction.payment.description}</td>
                      <td className="priceCell ltrTd">{accounting.formatMoney(transaction.amount, '', ',')}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="paginationWrapp">
                <Page
                  defaultCurrent={1}
                  total={this.state.countAll}
                  onResultFetched={this.onResultFetched.bind(this)}
                  urlParams={params}
                  url={REPORT_RETAIL.REPORT_RETAIL_CUSTOMER_TRANSACTION_MULTIPLE}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default UsersTransaction
